import { Link } from 'react-router-dom';

import '../style/NotFoundPage.css';

const NotFoundPage = () => {
  return (
    <>
      <meta name='robots' content='noindex' />
      <title>REM 404</title>

      <div className='not-found-page-container'>
        <h1>404 - Page Not Found</h1>
        <p>
          Oops! The page you're looking for doesn't exist or has been moved.
        </p>

        <Link className='home-link' to='/'>
          Go to Home Page
        </Link>
      </div>
    </>
  );
};

export default NotFoundPage;
